/** EN */
import general from './en-us/general.json';
import litholens from './en-us/litholens.json';
import projects from './en-us/projects.json';
import company from './en-us/company.json';
import rectify from './en-us/rectify.json';
import atoms_logs_uploader from './en-us/atoms-logs-uploader.json';
import print from './en-us/print.json';
import usage from './en-us/usage-report.json';
import trainModel from './en-us/train-model.json';
import atoms_log_card from './en-us/atoms-log-card.json';
import visualizer from './en-us/visualizer.json';
/** ES */
import generalES from './es/general.json';
import litholensES from './es/litholens.json';
import projectsES from './es/projects.json';
import companyES from './es/company.json';
import rectifyES from './es/rectify.json';
import atoms_logs_uploaderES from './es/atoms-logs-uploader.json';
import visualizerES from './es/visualizer-v2.json';
import printES from './es/print.json';
import usageES from './es/usage-report.json';
import trainModelES from './es/train-model.json';
import atoms_log_cardES from './es/atoms-log-card.json';

// merge english sources
export const en = {
  translation: Object.assign(
    {},
    general,
    litholens,
    projects,
    company,
    rectify,
    atoms_logs_uploader,
    visualizer,
    print,
    usage,
    trainModel,
    atoms_log_card,
  ),
};

// merge spanish sources
export const es = {
  translation: Object.assign(
    {},
    generalES,
    litholensES,
    projectsES,
    companyES,
    rectifyES,
    atoms_logs_uploaderES,
    visualizerES,
    printES,
    usageES,
    trainModelES,
    atoms_log_cardES,
  ),
};
